<template>

  <portlet
      :icon="'fal fa-chart-pie portlet-icon'"
      :title="$t('oeeAnalytics.downTimes.title')"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20 oee-chart-portlet"
  >
    <template slot="actionsBlock">

      <div class="row oee-controls">

        <div class="col-2">
          <label for="downtimes-unscheduled">{{ $t('oeeAnalytics.downTimes.filters.showUnscheduled') }}</label>
          <select name="" class="form-control rounded-0" v-model="filters.showUnscheduled" id="downtimes-unscheduled">
            <option :value="true">Show</option>
            <option :value="false">Hide</option>
          </select>
        </div>
        <div class="col-6">
          <div class="dropdown rounded-0">
            <label for="">Filter</label>
            <button class="btn btn-outline-filter dropdown-toggle form-control rounded-0" type="button"
                    v-if="downTimes">

              <span>Filterd reasons ({{ filters.selectedReasons.length }})</span>
            </button>
            <div class="dropdown-menu rounded-0 ">
              <input v-model="search" class="form-control mb-3" type="text"
                     :placeholder="$t('jobs.filter.search')">
              <div class="button-group">
                <button class="btn btn-primary mr-3 rounded-0" @click="selectAllReasons()">Select all</button>
                <button class="btn btn-outline-primary rounded-0" @click="clearSelectedReasons()">clear selection
                </button>
              </div>
              <div class="option-wrapper">
                <div class="custom-control custom-checkbox" v-for="(reason, index) in getFullUniqueReasons"
                     :key="'reason-'+index">
                  <input v-model="filters.selectedReasons"
                         :value="reason"
                         type="checkbox"
                         :id="'reason-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="'reason-'+index">
                    <span>{{ reason }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="col-4">
            <div class="dropdown rounded-0">
              <label for="">Filter Subtypes</label>
              <button class="btn btn-outline-filter dropdown-toggle form-control rounded-0" type="button"
                      v-if="downTimes">

                <span>Filterd subTypes ({{ filters.selectedSubTypes.length }})</span>
              </button>
              <div class="dropdown-menu  subtype rounded-0 ">
<!--                <input v-model="search" class="form-control mb-3" type="text"-->
<!--                       :placeholder="$t('jobs.filter.search')">-->

                <div class="option-wrapper">
                  <div class="custom-control custom-checkbox" v-for="(type, index) in subTypes"
                       :key="'reason-'+index">
                    <input v-model="filters.selectedSubTypes"
                           :value="type.value"
                           type="checkbox"
                           :id="'reason-type'+index"
                           class="custom-control-input"
                    >
                    <label class="custom-control-label" :for="'reason-type'+index">
                      <span>{{ type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--          <label for="downtimes-reason">{{ $t('oeeAnalytics.downTimes.filters.reason') }}</label>-->
          <!--          <select name="" class=form-control v-model="filters.selectedReason" id="downtimes-unscheduled">-->
          <!--            <option :value="null">All</option>-->
          <!--            <option v-for="reason in getFullUniqueReasons" :value="reason">{{ reason }}</option>-->
          <!--          </select>-->
        </div>

    </template>
    <template slot="portletBody">
      <div class="row">
        <div class="col-12">
          <Pareto v-if="!loading"
                  @reasonSelected="reasonSelected($event)"
                  :downTimes="getDownTimes"
                  :uniqueReasons="getUniqueReasons"/>
          <componentLoadSpinnerV2 v-else :loading="true"/>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-12">
          <Trend v-if="!loading"
                 :downTimes="getDownTimes"
                 :uniqueReasons="getUniqueReasons"
          ></Trend>
          <componentLoadSpinnerV2 v-else :loading="true"/>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-sm-12 col-md-4">
          <TopBottom v-if="!loading"
                     @reasonSelected="reasonSelected($event)"
                     :downTimes="getDownTimes"
                     :uniqueReasons="getUniqueReasons"/>
          <componentLoadSpinnerV2 v-else :loading="true"/>
        </div>
        <div class="col-sm-12 col-md-8">
          <Table v-if="!loading"
                 :downTimes="getDownTimes"
                 :uniqueReasons="getUniqueReasons"/>
          <componentLoadSpinnerV2 v-else :loading="true"/>
        </div>
      </div>
    </template>
  </portlet>


</template>

<script>
import Pareto from '@/components/oeeAnalytics/components/downTimes/DownTimePareto'
import Trend from '@/components/oeeAnalytics/components/downTimes/DownTimeTrend'
import TopBottom from '@/components/oeeAnalytics/components/downTimes/DownTimeTopBottom'
import Table from '@/components/oeeAnalytics/components/downTimes/DownTimeTable'
import {mapGetters} from "vuex";
import ComponentLoadSpinnerV2 from "@/components/general/ComponentLoadSpinnerV2";
import downTimesOee from "@/mixins/oeeAnalytics/downTimes";

export default {
  name: "DownTimesOEEAnalytics",

  mixins: [downTimesOee],
  props: ['updateDataTrigger'],
  components: {
    ComponentLoadSpinnerV2,
    Pareto,
    Trend,
    TopBottom,
    Table
  },
  data() {
    return {
      loading: true,
      search: '',
      subTypes:[{
        value: 'no-order',
        label: this.$t('reasonTrees.plannedSubTypes.no-order')
      },{
        value: 'technical',
        label:  this.$t('reasonTrees.plannedSubTypes.technical')
      },{
        value: 'organizational',
        label:  this.$t('reasonTrees.plannedSubTypes.organizational')
      },
        {
          value: 'setup',
          label:  this.$t('reasonTrees.plannedSubTypes.setup')
        }
      ],
      filters: {
        selectedSubTypes: [],
        showUnscheduled: false,
        selectedReason: null,
        selectedReasons: [],
      },
      downTimes: null,
    }
  },
  computed: {
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getUnit', 'getSelectedDateParsedToString', 'getQueryFilters']),
    getFullUniqueReasons() {
      const self = this
      let downTimes = _.filter(this.downTimes, downtime => {
        if (this.filters.showUnscheduled) {
          return downtime
        } else {
          return !downtime.unscheduled
        }
      }).filter(dt => {
        if (this.search.length) {
          return this.joinReasonsToString(dt.reason).toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
        } else {
          return dt
        }
      })
      return [...new Set(_.clone(downTimes).map(dt => {
            // dt.reason = _.filter([dt.reason_1,dt.reason_2,dt.reason_3], rs=>{ return rs !== null})
            try {
              if (dt.reason) {
                return this.joinReasonsToString(dt.reason)
              }
            } catch (e) {

            }
          }
      ))].filter(Boolean)
    },
    getUniqueReasons() {
      const self = this
      return [...new Set(_.clone(self.getDownTimes).map(dt => {
            // dt.reason = _.filter([dt.reason_1,dt.reason_2,dt.reason_3], rs=>{ return rs !== null})
            try {
              if (dt.reason) {
                return this.joinReasonsToString(dt.reason)
              }
            } catch (e) {
              console.log(e)
            }
          }
      ))].filter(Boolean)
    },
    getDownTimes() {
      return _.orderBy(_.filter(this.downTimes, downtime => {
        if (this.filters.showUnscheduled) {
          return downtime
        } else {
          return !downtime.unscheduled
        }
      }).filter(dt =>{

        if(this.filters.selectedSubTypes.length) {
          return _.includes(this.filters.selectedSubTypes, dt.reasonSubType)
        }else{
          return dt
        }
      }).filter(dt => {
        if (this.filters.selectedReasons.length) {
          return _.includes(this.filters.selectedReasons, this.joinReasonsToString(dt.reason))
          // return dt.reason.join('|') == this.filters.selectedReason
        } else {
          return dt
        }
      }), ['duration'], ['desc'])
    },
  },
  methods: {
    selectAllReasons() {
      this.filters.selectedReasons = this.getFullUniqueReasons
    },
    clearSelectedReasons() {
      this.filters.selectedReasons = []
    },
    reasonSelected(reason) {
      this.filters.selectedReason = reason
    },
    async getDownTimesFromBigQuery() {
      this.loading = true
      this.downTimes = null
      this.$store.commit('oeeAnalytics/setData', {type: 'downTimes', data: []})

      let downTimes = await this.$FUNCTIONS.OeeAnalytics("getDownTimes", this.getQueryFilters).catch(e => {
        this.loading = false
      })

      this.loading = false
      this.clearSelectedReasons()
      this.downTimes = downTimes.data ? downTimes.data : null

      this.$store.commit('oeeAnalytics/setData', {type: 'downTimes', data: this.downTimes})
    }
  },
  watch: {
    getQueryFilters(newV, oldV) {
      if (newV) {
        // this.getDownTimesFromBigQuery()

      }
    },
    'updateDataTrigger':
        {
          deep: true,
          handler(newValue, oldValue) {
            this.getDownTimesFromBigQuery();
          }
        }
  },
  created() {
    this.getDownTimesFromBigQuery()
  },

}
</script>

<style lang="scss" scoped>
.oee-controls {
  width: 1200px;
}

.dropdown-menu {
  height: 300px;
  overflow-y: auto;
   &.subtype{
    height:135px;
  }
}
</style>

<style>
/* Override the height of the porlet head (only if its part of the oee-chart-portlet so it doesnt change anywhere else) */
.oee-chart-portlet > .m-portlet__head {
  height: 10rem !important;
}


</style>